module.exports = __webpack_public_path__ + "img/yxkdiag4.554b3250.svg";